<template>
  <div class="live-container">
    <!-- 顶部状态导航 -->
    <div class="status-nav">
      <div v-for="status in statusList" :key="status.id" class="status-item"
        :class="{ active: currentStatus === status.id }" @click="currentStatus = status.id">
        {{ status.name }}
      </div>
    </div>

    <!-- 直播列表 -->
    <div class="live-list">
      <div v-for="(live, index) in liveList" :key="index" class="live-item">
        <div class="live-info">
          <div class="live-title">{{ live.title }}</div>
          <div class="live-time">直播时间: {{ live.time }}</div>
        </div>
        <div class="live-status" v-if="live.isLive">直播中</div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue'

// 状态列表
const statusList = [
  { id: 'live', name: '直播中' },
  { id: 'pending', name: '待开播' },
  { id: 'ended', name: '已结束' },
  { id: 'cancelled', name: '已取消' },
  { id: 'all', name: '全部' }
]

// 当前选中的状态
const currentStatus = ref('live')

// 直播列表数据
const liveList = [
  {
    title: '自研直播测试',
    time: '2025-01-22 12:00:00',
    isLive: true
  },
  {
    title: '中秋好礼享不停',
    time: '2025-01-22 12:00:00',
    isLive: true
  },
  {
    title: '国庆好礼享不停',
    time: '2025-01-22 12:00:00',
    isLive: true
  }
]
</script>

<style lang="less" scoped>
.live-container {
  min-height: 100vh;
  padding-bottom: 70px;
}

/* 状态导航样式 */
.status-nav {
  display: flex;
  background-color: #fff;
  padding: 15px 0;
  overflow-x: auto;
  white-space: nowrap;
  border-bottom: 1px solid #F6F6F6;

  &::-webkit-scrollbar {
    display: none;
  }
}

.status-item {
  padding: 0 15px;
  font-size: 15px;
  color: #999999;
  cursor: pointer;
  position: relative;

  &.active {
    color: #DCBB89;
    font-weight: 500;
  }

  &.active::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 2px;
    background-color: #DCBB89;
  }
}

/* 直播列表样式 */
.live-list {
  padding: 10px 17px;
}

.live-item {
  background-color: #fff;
  padding: 15px 13px;
  margin-bottom: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.live-info {
  flex: 1;
}

.live-title {
  font-size: 17px;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
  font-family: 'PingFang SC-Medium';
}

.live-time {
  font-size: 13px;
  color: #666;
}

.live-status {
  font-size: 14px;
  color: #FF7123;
  font-weight: 500;
}
</style>
